export default "__VITE_ASSET__CsPJjveD__"